module.exports = __webpack_public_path__ + "site/img/153.2119abc9.jpg";